module.exports = __webpack_public_path__ + "img/MBOM-Impact-HSV-min.86943cd9.png";